module.exports = __webpack_public_path__ + "static/media/baker-steel-electrum.b31fa9ad.csv";